import { z } from 'zod';
import { CapacityBindingSchema } from '../../shared/capacity';
import { StepActionTypeSchema } from '../../shared/step-action-type.schema';
import { SystemLogoDataSchema } from '../../shared/logo.schema';
import { AvatarSchema } from '../../shared/avatar.schema';
// ── Stat Cards ──────────────────────────────────────────────────────────
export const DashboardStatsSchema = z.object({
    activeProcessCount: z.number(),
    totalActivityCount: z.number(),
    usedSystemCount: z.number(),
    networkInteractionCount: z.number(),
    directContactCount: z.number(),
    indirectContactCount: z.number(),
    topActivities: z.array(z.object({
        name: z.string(),
        frequency: z.string().nullable(),
        frequencyTimesPerPeriod: z.number().nullable()
    })).max(3),
    topSystems: z.array(z.object({
        name: z.string(),
        usageHours: z.number()
    })).max(2)
});
// ── Process Activity (nested inside a process) ─────────────────────────
export const DashboardActivitySchema = z.object({
    _id: z.string(),
    name: z.string(),
    actionType: StepActionTypeSchema
});
// ── Process ─────────────────────────────────────────────────────────────
export const DashboardProcessSchema = z.object({
    _id: z.string(),
    name: z.string(),
    department: z.object({
        _id: z.string(),
        name: z.string()
    }).nullable(),
    category: z.enum([
        'core',
        'management',
        'support'
    ]).nullable(),
    stepCount: z.number(),
    userInvolvedStepCount: z.number(),
    capacityBinding: CapacityBindingSchema.nullable(),
    activities: z.array(DashboardActivitySchema)
});
// ── System ──────────────────────────────────────────────────────────────
export const DashboardSystemSchema = z.object({
    _id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    category: z.string().nullable(),
    logo: SystemLogoDataSchema.nullable(),
    usageHours: z.number(),
    processCount: z.number()
});
// ── CoWorker ────────────────────────────────────────────────────────────
export const DashboardCoWorkerSchema = z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    role: z.object({
        _id: z.string(),
        name: z.string()
    }).nullable(),
    avatar: AvatarSchema.pick({
        thumbnail: true,
        medium: true
    }).nullable(),
    relationship: z.enum([
        'direct',
        'upstream',
        'downstream'
    ])
});
// ── Top-level Response ──────────────────────────────────────────────────
export const ShowDashboardResponseSchema = z.object({
    stats: DashboardStatsSchema,
    processes: z.array(DashboardProcessSchema),
    systems: z.array(DashboardSystemSchema),
    coWorkers: z.array(DashboardCoWorkerSchema)
});
export const ShowDashboardRequestSchema = z.void();

//# sourceMappingURL=show-dashboard.schema.js.map